 /**
  * 操作权限处理
  * Copyright (c) 2019 ruoyi
  */

 import store from '@/store'
import { Toast } from 'vant'

 export default {
     inserted(el, binding, vnode) {
        const { value } = binding
        //  const all_permission = "*:*:*";
        const permissions = store.state.user.inspectionRoles
        if(permissions.length == 0){
            el.style.visibility = 'hidden'
        }else {
            if(value && value instanceof Array && value.length > 0){
                const isBtnPermis = permissions.some( permissions => {
                    return value.includes(permissions)
                })
                if(!isBtnPermis){
                    el.style.visibility = 'hidden'
                }
            }else{
                el.style.visibility = 'hidden'
            }
        }
     }
 }